import { createRouter, createWebHistory } from 'vue-router'
import Race2023 from '@/views/Race2023.vue'
import Training2024 from '@/views/Training2024.vue'
import Race2024 from '@/views/Race2024.vue'
import Race2025 from '@/views/Race2025.vue'
import RaceOct2025 from '@/views/RaceOct2025.vue'
import Race2026 from '@/views/Race2026.vue'
import RaceCanicross from '@/views/Race_canicross_2026/RaceCanicross2026.vue'
import RegisterCanicross2026 from '@/views/Race_canicross_2026/RegisterCanicross2026.vue'
import ConfirmationRegister from '@/views/Race_canicross_2026/ConfirmationRegister.vue'
import ObstacleRace2026 from '@/views/obstacle_race2026/views/ObstacleRace2026.vue'
import RegisterObstacleRace2026 from '@/views/obstacle_race2026/views/RegisterObstacleRace2026.vue'
import ConfirmationRegisterObstacle from '@/views/obstacle_race2026/views/ConfirmationRegisterObstacleRace2026.vue'
import WaterfalRace from '@/views/reto_cascadas/views/WaterfallRace.vue'
import WaterfallRegister from '@/views/reto_cascadas/views/WaterfallRegister.vue'
import WaterfallConfirmationRegister from '@/views/reto_cascadas/views/WaterfallConfirmationRgister.vue'

const routes = [
  // Ruta Home
  {
    path: '/',
    name: 'Reto Entre Cascadas 2026',
    component: WaterfalRace
  },
  // Demas carreras
  {
    path: '/carrera-2023',
    name: 'Carrera 2023',
    component: Race2023
  },
  {
    path: '/carrera-2024',
    name: 'Carrera 2024',
    component: Race2024
  },
  {
    path: '/entrenamiento-2024',
    name: 'Entrenamiento 2024',
    component: Training2024
  },
  {
    path: '/carrera-2025',
    name: 'Carrera 2025',
    component: Race2025
  },
  {
    path: '/carrera-octubre-2025',
    name: 'Carrera Octubre 2025',
    component: RaceOct2025
  },
  {
    path: '/carrera-bioparque-2026',
    name: 'Carrera Bioparque 2026',
    component: Race2026
  },
  {
    path: '/carrera-canicross-2026',
    name: 'Carrera Canicross 2026',
    component: RaceCanicross
  },
  {
    path: '/registro-canicross-2026',
    name: 'Registro Canicross 2026',
    component: RegisterCanicross2026
  },
  {
    path: '/confirmacion-registro/:numeroCorredor',
    name: 'Confirmación Registro',
    component: ConfirmationRegister,
    props: true
  },
  {
    path: '/carrera-obstaculos-julio-2026',
    name: 'Carrera Obstaculos Julio 2026',
    component: ObstacleRace2026
  },
  {
    path: '/registro-obstaculos-2026',
    name: 'Registro Obstaculos 2026',
    component: RegisterObstacleRace2026
  },
  {
    path: '/confirmacion-registro-julio-2026/:numeroCorredor',
    name: 'Confirmacion registro julio 2026',
    component: ConfirmationRegisterObstacle
  },
  {
    path: '/registro-reto-cascadas',
    name: 'Registro Reto Entre Cascadas 2026',
    component: WaterfallRegister
  },
  {
    path: '/confirmacion-registro-reto-cascadas/:numeroCorredor',
    name: 'Confirmacion registro cascadas 2026',
    component: WaterfallConfirmationRegister,
    props: true
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }
  }
})

export default router
